import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SemsoPdfViewerComponent } from './semso-pdf-viewer.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { MatButtonModule } from '@angular/material';

@NgModule({
  imports: [
    CommonModule,
    PdfViewerModule,
    MatButtonModule
  ],
  declarations: [SemsoPdfViewerComponent],
  exports: [SemsoPdfViewerComponent]
})
export class SemsoPdfViewerModule { }



// WEBPACK FOOTER //
// ./src/app/semso-pdf-viewer/semso-pdf-viewer.module.ts